import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const ArchiveDeliveryWarehouseByIdContentType = '' as const;
export type ArchiveDeliveryWarehouseByIdRequest = void;
export type ArchiveDeliveryWarehouseByIdResponses = LinkCommonErrorResponses & {
    /**
     * @description Warehouse archived
     */
    '200': {
        'application/json': unknown;
    };
};
export type ArchiveDeliveryWarehouseByIdResponseSuccess =
    ArchiveDeliveryWarehouseByIdResponses['200']['application/json'];
export type ArchiveDeliveryWarehouseByIdSearchParams = undefined;
export type ArchiveDeliveryWarehouseByIdPathParameters = {
    warehouse_id: string;
};
export const ArchiveDeliveryWarehouseByIdUrl = '/delivery/warehouse/{warehouse_id}' as const;
export const ArchiveDeliveryWarehouseByIdMethod = 'DELETE' as const;
export const getArchiveDeliveryWarehouseByIdUrl = (params: ArchiveDeliveryWarehouseByIdPathParameters) =>
    ArchiveDeliveryWarehouseByIdUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof ArchiveDeliveryWarehouseByIdPathParameters) => String(params[param])
    );
